<template>
  <Listbox
    v-slot="{ open }"
    v-model="selectedValues"
    multiple
    :disabled="disabled"
  >
    <div class="group relative">
      <template v-if="label">
        <BaseLabelTop
          :target="name"
          :label="label"
          :disabled="disabled"
          :required="required"
        />
      </template>

      <ListboxButton
        class="relative w-full cursor-pointer rounded-md border bg-white py-1 text-left transition-all sm:text-sm dark:border-slate-300 dark:bg-slate-700 dark:text-white"
        :class="[open ? 'border-slate-300 pl-2' : 'pl-2']"
      >
        <div class="flex flex-row flex-wrap items-center gap-1">
          <template v-if="selectedOptions.length">
            <span
              v-for="status in selectedOptions"
              :key="status.id"
              class="flex items-center gap-1 rounded bg-gray-100 px-2 py-0.5 text-xs dark:bg-slate-600"
            >
              <span
                :data-tint="status.bg_color"
                class="from-primary-400 to-primary-600 h-2 w-2 rounded bg-gradient-to-br"
              ></span>
              {{ status.name?.toLowerCase() }}
            </span>
          </template>

          <span v-else class="text-gray-500">
            {{ $t('global.no_tag') }}
          </span>
        </div>
      </ListboxButton>

      <transition
        leave-active-class="transition duration-100 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ListboxOptions
          class="absolute z-90 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm dark:border dark:border-white dark:bg-slate-700 dark:text-white"
        >
          <ListboxOption
            v-for="(status, index) in options"
            :key="index"
            v-slot="{ active, selected }"
            :value="status.id"
            as="template"
          >
            <li
              :class="[
                active ? 'bg-primary-300 text-white' : 'text-gray-900',
                'relative cursor-default px-2 py-1 select-none dark:text-white'
              ]"
            >
              <div class="flex flex-row items-center justify-between">
                <div class="flex flex-row items-center gap-2">
                  <span
                    :data-tint="status.bg_color"
                    class="from-primary-400 to-primary-600 h-3 w-3 rounded bg-gradient-to-br"
                  ></span>
                  <span
                    :class="[
                      selected ? 'font-medium' : 'font-normal',
                      'block truncate'
                    ]"
                  >
                    {{ status.name?.toLowerCase() }}
                  </span>
                </div>

                <span v-if="selected" class="text-primary font-bold">
                  <FontAwesomeIcon icon="check" />
                </span>
              </div>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
    <template v-if="true">
      {{ checkClosed(open) }}
    </template>
  </Listbox>

  <div
    v-for="(error, index) in errors"
    :key="index"
    class="form-help text-red-600"
  >
    {{ $t(error, { attribute: $t('attributes.' + name) }) }}
  </div>
</template>

<script>
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption
} from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BaseLabelTop from '@c/addf-package/components/BaseLabel/BaseLabelTop.vue'

export default {
  name: 'StatusMultiInput',
  components: {
    BaseLabelTop,
    FontAwesomeIcon,
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      required: true
    },
    disabled: Boolean,
    label: String,
    required: Boolean,
    name: String,
    errors: Array
  },
  emits: ['update:modelValue', 'status-changed'],
  data() {
    return {
      wasOpen: false,
      initialSelection: []
    }
  },
  computed: {
    selectedOptions() {
      return this.options.filter((option) =>
        this.modelValue.includes(option.id)
      )
    },
    selectedValues: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.wasOpen = false
    })
  },
  methods: {
    checkClosed(open) {
      if (!this.wasOpen && open) {
        this.initialSelection = [...this.selectedValues]
      }

      if (this.wasOpen && !open) {
        // dropdown vient de se fermer
        const changed =
          this.selectedValues.length !== this.initialSelection.length ||
          this.selectedValues.some(
            (val) => !this.initialSelection.includes(val)
          )

        if (changed) {
          this.$emit('status-changed', this.selectedValues)
        }
      }
      this.wasOpen = open
    }
  }
}
</script>
